// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b5ed4713","102":"30b93eaa","787":"9f5413c8","968":"68872d40"}[chunkId] + ".chunk.js";
};